import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar, Card, Modal, Alert, Spinner } from 'react-bootstrap';
import { useOutletContext, useNavigate } from 'react-router-dom';
import spinnerIcon from './/./../assets/img/loadingSpinner.gif'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import { useAuth0 } from "@auth0/auth0-react";
import { apiPost, apiGet, apiPutBlob } from "../services/AuthService.js";
import { BlockBlobClient } from "@azure/storage-blob";
import JSZip from "jszip";
import { detectImportFileKind, isFileKindMismatch, fileKindLabel, fileKindForFileTypeId } from "../lib/detect-import-file-kind.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight, faFileLines, faFileArrowUp, faFileCode } from '@fortawesome/free-solid-svg-icons'
import {
    btnGold, btnGoldHover, FOCUS_GOLD, COLORS,
    header, footer, goldLinkBase, addUnderline, removeUnderline,
    boxshadowHover, boxshadowUnHover,
    showAdvancedBtn, searchBtn, uploadBtn, resetFiltersBtn, sourceDataBtn,
    statusColors, darkStatusColors,
    formLabel, columnTitle, columnSortLink, goldInputFocus, statusLabel,
    frame, goldFaPlus, faIconStyle,
    inputSm, paginationStyle, activePaginationStyle,
    dropDownToggle, dropDownInput, dropDownMenu, tableRowHover, tableRowUnHover, stickyThStyle,
    filterActiveIndicator, backBtn, btnRed
} from '../styles/goldTheme.js'

function CheckDateConfirmationModal(props) {
    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        if (day === undefined) {
            return `${month}/${year}`
        }
            return `${month}/${day}/${year}`;
        }
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>Confirm Check Date</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container style={{ height: '125px' }} >
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center', textAlign: "center", marginBottom: '-10px' }}>
                            <p>Please ensure that the check date provided below is correct. Check date entered must match date in import file.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center', marginBottom: '-10px', marginTop: '10px', }}>
                            <p>
                                <strong>
                                    {formatDate(props.checkDate)}
                                </strong>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'left' }}>
                            <Button
                                style={{
                                    ...btnRed,
                                }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnRed))}
                                onClick={props.onHide}
                            >
                                Cancel
                            </Button>
                        </Col>
                        <Col style={{ display: 'flex', justifyContent: 'right' }}>
                            <Button
                                style={{
                                    ...btnGold,
                                }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                onClick={() => props.handleBlobUpload()}
                            >
                                Confirm
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}
function InvoiceDateConfirmationModal(props) {
    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        if (day === undefined) {
            return `${month}/${year}`
        }
            return `${month}/${day}/${year}`;
        }
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>Confirm Invoice Date</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container style={{ height: '125px' }} >
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center', textAlign: "center", marginBottom: '-10px' }}>
                            <p>Please ensure that the invoice date provided below is correct. Invoice date entered must match date in import file.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center', marginBottom: '-10px', marginTop: '10px', }}>
                            <p>
                                <strong>
                                    {formatDate(props.checkDate)}
                                </strong>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'left' }}>
                            <Button
                                style={{
                                    ...btnRed,
                                }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnRed))}
                                onClick={props.onHide}
                            >
                                Cancel
                            </Button>
                        </Col>
                        <Col style={{ display: 'flex', justifyContent: 'right' }}>
                            <Button
                                style={{
                                    ...btnGold,
                                }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                onClick={() => props.handleBlobUpload()}
                            >
                                Confirm
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}
function Ten99ConfirmationModal(props) {
    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
            return `${year}`;
        }
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>Confirm Tax Year and Version</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container style={{ height: '140px' }} >
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center', textAlign: "center", marginBottom: '-10px' }}>
                            <p>Please ensure that the tax year and version provided below is correct. Tax year and version entered must match the import file.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center', marginBottom: '-10px', marginTop: '10px', }}>
                            <p>
                                <strong>
                                    {formatDate(props.checkDate)}
                                </strong>
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center', marginBottom: '-10px', marginTop: '10px', }}>
                            <p>
                                <strong>
                                    {props.ten99Version}
                                </strong>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'left' }}>
                            <Button
                                style={{
                                    ...btnRed,
                                }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnRed))}
                                onClick={props.onHide}
                            >
                                Cancel
                            </Button>
                        </Col>
                        <Col style={{ display: 'flex', justifyContent: 'right' }}>
                            <Button
                                style={{
                                    ...btnGold,
                                }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                onClick={() => props.handleBlobUpload()}
                            >
                                Confirm
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}

function FileTypeMismatchModal(props) {
    //Deliberately reads as a WARNING rather than another confirmation. This modal appears right
    //after the gold check date / invoice date confirmation, so it sets itself apart through the
    //body instead of the chrome: the mismatch callout states the discrepancy, and the button
    //emphasis is inverted (Cancel is primary, Continue is de-emphasised) to steer the user
    //toward the safe action. The header is intentionally left neutral.
    const ghostBtn = {
        backgroundColor: "transparent",
        borderColor: "#9aa0a6",
        color: COLORS.black,
        fontWeight: 600,
        boxShadow: "none"
    };

    const fieldLabel = {
        fontSize: ".72rem",
        letterSpacing: ".05em",
        textTransform: "uppercase",
        color: "#6b7280",
        fontWeight: 700
    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title
                    id="contained-modal-title-vcenter"
                    style={{ flexGrow: 1, textAlign: "center", paddingLeft: "2rem" }}
                >
                    <h4 style={{ margin: 0 }}>Possible Wrong File Type</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ paddingTop: "20px" }}>
                <Container>
                    {/* the discrepancy as a scannable comparison rather than a sentence */}
                    <Row>
                        <Col>
                            <div style={{
                                borderLeft: "4px solid " + COLORS.red,
                                backgroundColor: "rgba(229, 57, 53, 0.07)",
                                borderRadius: "0 4px 4px 0",
                                padding: "12px 16px"
                            }}>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 32px" }}>
                                    <div>
                                        <div style={fieldLabel}>You selected</div>
                                        <div style={{ fontSize: "1.05rem", fontWeight: 700 }}>{props.selectedLabel}</div>
                                    </div>
                                    <div>
                                        <div style={fieldLabel}>File looks like</div>
                                        <div style={{ fontSize: "1.05rem", fontWeight: 700, color: COLORS.red }}>{props.detectedLabel}</div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ marginTop: "16px" }}>
                            <p style={{ marginBottom: 0 }}>
                                Uploading the wrong type will fail during processing. Cancel to change the file
                                type or pick a different file. Only continue if you are sure this file is correct.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        {/* Cancel is the recommended path here, so it carries the primary treatment */}
                        <Col style={{ display: "flex", justifyContent: "left" }}>
                            <Button
                                style={{
                                    ...btnGold,
                                }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                onClick={props.onHide}
                            >
                                Cancel
                            </Button>
                        </Col>
                        <Col style={{ display: "flex", justifyContent: "right" }}>
                            <Button
                                style={{
                                    ...ghostBtn,
                                }}
                                onMouseEnter={e => Object.assign(e.target.style, { backgroundColor: "#f1f1f1" })}
                                onMouseLeave={e => Object.assign(e.target.style, { backgroundColor: "transparent" })}
                                onClick={() => props.handleBlobUpload(true)}
                            >
                                Continue Anyway
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}

const Import = props => {

    //properties
    const baseUrl = process.env.REACT_APP_API_BASEURL;
    const { getAccessTokenSilently, user } = useAuth0();

    //stateful properties (hooks)
    const navigate = useNavigate();
    const [currentAccount, accountProfile, setAccountProfile, toggleIsShowSidebarMd, setIsShowSidebarMd] = useOutletContext();
    const [pageStatus, setPageStatus] = useState('loading');
    const [dataStatus, setDataStatus] = useState('');
    const [pageErrors, setPageErrors] = useState('');
    const [dataErrors, setDataErrors] = useState('');
    const [displayResultGrid, setDisplayResultGrid] = useState(true);
    const [selectedFile, setSelectedFile] = useState();

    const [dateExtractFile, setDateExtractFile] = useState();
    const [extractedCheckDate, setExtractedCheckDate] = useState('');

    const [isFilePicked, setIsFilePicked] = useState(false);
    const [years, setYears] = useState([]);
    const [dataCriteria, setDataCriteria] = useState({
        skipCount: 0,
        takeCount: 10,
        checkDate: '',
        description: '',
        ten99Version: 'Original',
    });
    const [fileTypes, setFileTypes] = useState(['Select File Type...', 'Revenue', 'JIB', 'Plant', '1099']);
    const [fileTypeCriteria, setFileTypeCriteria] = useState({ fileTypeId: '0' });
    const [alertShow, setAlertShow] = React.useState(false);
    const [alertVariant, setAlertVariant] = React.useState('danger');
    const [alertMessage, setAlertMessage] = React.useState('Document downloaded successfully!');
    const [progressStatus, setProgressStatus] = useState(0);
    const [checkDateConfirmationModalShow, setCheckDateConfirmationModalShow] = useState(false);
    const [invoiceDateConfirmationModalShow, setInvoiceDateConfirmationModalShow] = useState(false);
    const [ten99ConfirmationModalShow, setTen99ConfirmationModalShow] = useState(false);
    const [fileTypeMismatchModalShow, setFileTypeMismatchModalShow] = useState(false);
    const [detectedFileKind, setDetectedFileKind] = useState(null);
    const [isInvalid, setIsinvalid] = useState(false)
    const [isVersionInvalid, setIsVersioninvalid] = useState(false)
    const [isTen99MISC, setIsTen99MISC] = useState(false)

    const isJibEnabled = (baseUrl && (baseUrl.includes("local") || baseUrl.includes("dev") || baseUrl.includes("qa") || baseUrl.includes("totdata-api.azurewebsites.net")));
    const is1099Enabled = (baseUrl && (baseUrl.includes("local") || baseUrl.includes("dev") || baseUrl.includes("qa") || baseUrl.includes("totdata-api.azurewebsites.net")));

    const styles = {
        pickerWrap: {
            maxWidth: "1100px",
            margin: "12vh auto 16px auto",
            padding: "0 16px"
        },
        pickerTitle: {
            fontSize: "28px",
            fontWeight: 700,
            margin: "0 0 16px 0"
        },
        grid: {
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gap: "16px"
        },
        tile: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            padding: "28px",
            height: "150px",
            borderRadius: "16px",
            border: "1px solid #e5e7eb",
            background: "#ffffff",
            boxShadow: "0 4px 18px rgba(0,0,0,0.06)",
            cursor: "pointer",
            transition: "transform 150ms ease, box-shadow 150ms ease, border-color 150ms ease"
        },
        tileHover: {
            transform: "translateY(-2px)",
            boxShadow: "0 10px 24px rgba(0,0,0,0.10)"
        },
        tileActive: {
            border: "2px solid #0ea5e9",
            boxShadow: "0 12px 28px rgba(2,132,199,0.20)"
        },
        tileTitle: { fontSize: "20px", fontWeight: 700, marginBottom: "6px" },
        tileDesc: { fontSize: "14px", color: "#6b7280" },
        chevron: {
            position: "absolute",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "24px",
            opacity: 0.35
        }
    };

    const resetToSelection = () => {
        setAlertShow(false);
        setDataCriteria({
            skipCount: 0,
            takeCount: 10,
            checkDate: '',
            description: '',
            ten99Version: 'Original',
        });

        setIsFilePicked(false);
        setIsinvalid(false);
        setIsVersioninvalid(false);

        handleFileTypeChange({
            preventDefault: () => { },
            target: { name: "fileTypeId", value: "0" }
        });
    };

    const pickType = (id) => {
        handleFileTypeChange({
            preventDefault: () => { },
            target: { name: "fileTypeId", value: String(id) }
        });
    };

    //initialize page
    useEffect(() => {
        (async () => {
            //console.log('Initializing page...');

            if (setIsShowSidebarMd)
                setIsShowSidebarMd(true);

            await initializeForm()
                .then(response => {
                    setDataCriteria({
                        ...dataCriteria,
                        //TODO: temporarily commented checkDate out for development: uncomment for production
                        //checkDate: response.currDate
                    });
                    setYears(response.dates.years);
                    setPageStatus('ready')
                    setDataStatus('ready')
                })
                .catch(ex => {
                    setPageStatus('error');
                    setPageErrors(ex.message);
                })
                .finally(response => {
                    //do something
                })
        })();
    }, []);

    //initialize form
    const initializeForm = async () => {
        //console.log('Initializing form...');

        //get check date
        let currentDate = await getCurrentDate();

        //get dates for to/from dropdowns
        const dates = await getDates();
        
        return { success: true, currDate: currentDate, dates: dates };

        //TODO: might want to clean this up with .then /.catch, but how to do with multiple api calls?
        //.then(get other data)
        //.catch(ex => throw...)
    };

    const getCurrentDate = async () => {

        //TODO: apply timezone offset and set to first and last day of current month
        //https://stackoverflow.com/questions/23593052/format-javascript-date-as-yyyy-mm-dd

        const date = new Date();
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        // This arrangement can be altered based on how we want the date's format to appear.
        //let currentDate = `${year}-${month}-${day}`;
        const currentDate = date.toJSON().split('T')[0];
        console.log('CurrentDate: ' + currentDate); // "17-6-2022"

        return currentDate;
    };

    const getDates = () => {

        const currDate = new Date();
        //const day = date.getDate();
        const currMonth = currDate.getMonth() + 1;
        const currYear = currDate.getFullYear();

        //const fromMonth = currMonth === 1 ? 11 : currMonth - 1;   //temp for testing (to list Nov. for 3G LLC)
        //const fromMonth = currMonth === 1 ? 12 : currMonth - 2;
        //const fromYear = currMonth === 1 ? currYear - 1 : currYear;
        const fromMonth = currMonth < 3 ? (12 + currMonth) - 2 : currMonth - 2;
        const fromYear = currMonth < 3 ? currYear - 1 : currYear;

        const years = ['', currYear, currYear - 1, currYear - 2, currYear - 3, currYear - 4, currYear - 5, currYear - 6, currYear - 7];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        return { months: months, years: years, currMonth: currMonth, currYear: currYear, fromMonth: fromMonth, fromYear: fromYear };
    };

    //handle form control changes
    const handleChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;
        console.log('Field: ' + fieldName + ', Value: ' + value);

        setDataCriteria({
            ...dataCriteria,
            [fieldName]: value
        });

        if (fieldName === 'checkDate') {
            setIsinvalid(value === '');
        }

        if (fieldName === 'ten99Version') {
            setIsinvalid(value === '');
        }
    }

    //handle file type changes
    const handleFileTypeChange = async (e) => {
        e.preventDefault();
        setDataStatus('ready');

        const fieldName = e.target.name;
        const value = e.target.value;
        console.log('Field: ' + fieldName + ', Value: ' + value);

        setFileTypeCriteria({
            ...fileTypeCriteria,
            [fieldName]: value
        });

        //if (e.target.value === '1') {
            //await populateCheckStatements(0)
            //    .then(response => {
            //        if (response.data.length === 0) {
            //            console.log(response.data);
            //            setDataStatus('nodata')
            //        }
            //        else {
            //            //console.log('Check Count: ' + response.data[0].rowCount);
            //            setRowCount(response.data[0].rowCount);
            //            setCheckStatements(response.data);
            //            setDataStatus('ready')
            //        }
            //    })
            //    .catch(ex => {
            //        setDataStatus('error');
            //        setDataErrors(ex.message);
            //    })
            //    .finally(response => {
            //        //do something
            //    })
        //    setDataStatus('ready');
        //}
        //else {
        //    setDataStatus('ready');
        //}

        //if (e.target.value === '0') {
        //    setDisplayResultGrid(false);
        //} else {
        //    setDisplayResultGrid(true);
        //}
    };

    const supportedExtensions = ['.xml', '.txt', '.dat', '.csv'];

    //zip is accepted as a compression wrapper for Revenue/JIB, but not for 1099 - the 1099
    //file must be uploaded directly. drives both the file picker filter and the label below
    //so the two can never disagree.
    const acceptedExtensions = fileTypeCriteria.fileTypeId === '4'
        ? supportedExtensions
        : [...supportedExtensions, '.zip'];
    const acceptedExtensionsLabel = acceptedExtensions.map(ext => ext.toUpperCase()).join(', ');

    const hasSupportedExtension = (fileName) => {
        const name = (fileName || '').toLowerCase();
        return supportedExtensions.some(ext => name.endsWith(ext));
    };

    //peek inside a zip (reads the file list only, does not decompress contents) to fail fast.
    //a zip is only supported as a compression wrapper around exactly one supported data file.
    const validateZipContents = async (file) => {
        try {
            const zip = await JSZip.loadAsync(file);
            const fileEntries = Object.values(zip.files).filter(entry => !entry.dir);

            if (fileEntries.length === 0) {
                return { valid: false, message: 'The zip file is empty. Please upload a zip containing a single data file.' };
            }
            if (fileEntries.length > 1) {
                return { valid: false, message: 'The zip file must contain exactly one file.' };
            }

            const innerName = fileEntries[0].name.split('/').pop();
            if (!hasSupportedExtension(innerName)) {
                return { valid: false, message: 'The file inside the zip is not a supported type. Supported file types: .XML, .TXT, .DAT, .CSV' };
            }

            //hand back the inner entry so its contents can be type-sniffed. note JSZip has no
            //partial-entry decompression, so this expands the single inner file in memory.
            const innerFile = await fileEntries[0].async('blob');

            return { valid: true, innerName, innerFile };
        }
        catch (ex) {
            console.error('Zip read error:', ex);
            return { valid: false, message: 'The zip file could not be read. It may be corrupt.' };
        }
    };

    const changeHandler = async (event) => {
        console.log('changing...');

        console.log('Number of selected files: ' + event.target.files.length);

        if (event.target.files.length > 0) {
            const file = event.target.files[0];

            if (file.name.toLowerCase().endsWith('.zip')) {
                //zip upload is not supported for 1099 files
                if (fileTypeCriteria.fileTypeId === '4') {
                    setSelectedFile(null);
                    setIsFilePicked(false);
                    setAlertShow(true);
                    setAlertVariant('danger');
                    setAlertMessage('Zip upload is not supported for 1099 files. Please upload the file directly.');
                    setDataStatus('ready');
                    return;
                }

                //zip path: validate the single inner file before accepting
                const zipResult = await validateZipContents(file);
                if (!zipResult.valid) {
                    setSelectedFile(null);
                    setIsFilePicked(false);
                    setAlertShow(true);
                    setAlertVariant('danger');
                    setAlertMessage(zipResult.message);
                    setDataStatus('ready');
                    return;
                }

                setSelectedFile(file);
                setIsFilePicked(true);
                setAlertShow(false);
                setDetectedFileKind(zipResult.innerFile ? await detectImportFileKind(zipResult.innerFile) : null);
            }
            else if (!hasSupportedExtension(file.name)) {
                setSelectedFile(null);
                setIsFilePicked(false);
                setDetectedFileKind(null);
            }
            else {
                setSelectedFile(file);
                setIsFilePicked(true);

                //identify whether the contents look like the selected data type (Revenue/JIB/1099)
                setDetectedFileKind(await detectImportFileKind(file));

                //extract check date from file:
                //await extractCheckDate(event.target.files[0]);

                //extract ten99 Name from file:
                if (fileTypeCriteria.fileTypeId === '4') {
                    await extractTen99Name(file);
                }
            }
        }
        else {
            setSelectedFile(null);
            setIsFilePicked(false);
            setDetectedFileKind(null);
        }

        setDataStatus('ready')
    };

    const handleSubmission = async () => {
        setDataStatus('loading')

        const formData = new FormData();
        formData.append('uploadFile', selectedFile);

        const apiUrl = baseUrl + 'a_import?accountId=' + currentAccount.id + '&checkDate=' + dataCriteria.checkDate + '&description=' + dataCriteria.description;
        console.log(apiUrl);

        await importFile()
            .then(response => {
                if (response.success) {
                    console.log('Success:', response.success);
                    setDataStatus('ready');

                    setAlertMessage("Document uploaded successfully!  We've received your document for processing, and will send you emails regarding the status of the import.");
                    setAlertShow(true);
                    setAlertVariant('success');
                }
                else {
                    console.log('Failed:', response.statusText + ' : ' + response);
                    setDataErrors('');
                    setDataStatus('error');

                    setAlertShow(true);
                    setAlertVariant('danger');
                    setAlertMessage('Upload failed.');
                }
            })
            .catch((ex) => {
                console.error('Error:', ex);
                setDataErrors(ex.message);
                setDataStatus('error');

                setAlertShow(true);
                setAlertVariant('danger');
                setAlertMessage('Upload failed.');
            })
            .finally(response => {
                setSelectedFile(null);
                setIsFilePicked(false);

                setTimeout(() => {
                    setAlertShow(false);
                }, 5000);
            });
        
        return { success: true };
    };

    //1099 MISC name rule, applied to a file name (works for both a loose file and a zip's inner file)
    const applyTen99NameCheck = (fileName) => {
        if ((fileName || '').toLowerCase().includes('misc')) {
            setIsTen99MISC(true);
            setAlertShow(false);
        } else {
            setIsTen99MISC(false);
            setAlertShow(true);
            setAlertVariant('danger');
            setAlertMessage(
                "The file type you have selected is not supported. Please upload a 1099 MISC file."
            );
        }
    };

    const extractTen99Name = async (file) => {
        if (!file) return;
        applyTen99NameCheck(file.name);
        return;
    };

    const extractCheckDate = async (file) => {
        if (!file) return;

        const fileName = file.name.toLowerCase();

        const text = await file.text();

        let checkDateRaw = '';

        if (fileName.endsWith('.xml')) {
            const match = text.match(/<CheckDate>(.*?)<\/CheckDate>/i);
            if (match && match[1]) {
                checkDateRaw = match[1]; //should be in YYYY-MM-DD
            }
        } else if (fileName.endsWith('.dat')) { //handle .dat
            //find line containing "CHECK DATE:"
            const lines = text.split('\n');
            for (let line of lines) {
                const dateIndex = line.indexOf('CHECK DATE:');
                if (dateIndex !== -1) {
                    const afterCheckDate = line.substring(dateIndex + 'CHECK DATE:'.length).trim();
                    const dateMatch = afterCheckDate.match(/(\d{2}\/\d{2}\/\d{4})/);
                    if (dateMatch && dateMatch[1]) {
                        //convert to YYYY-MM-DD
                        const [month, day, year] = dateMatch[1].split('/');
                        checkDateRaw = `${ year }-${ month }-${ day }`;
                        break;
                    }
                }
            }
        } else { //handle .txt
            const lines = text.split('\n');
            for (let line of lines) {
                if (line.startsWith('C') || line.startsWith('c')) {
                    //extract first continuous string after 'C'
                    const cString = line.split(' ')[0];
                    if (cString.length >= 8) {
                        //get last 8 characters
                        const candidate = cString.slice(-8);
                        //confirm all digits and a valid date
                        if (/^\d{8}$/.test(candidate)) {
                            var checkDateUnformatted = candidate
                            checkDateRaw = `${checkDateUnformatted.substring(0, 4)}-${checkDateUnformatted.substring(4, 6)}-${checkDateUnformatted.substring(6, 8)}`;
                            break;
                        }
                    }
                }
            }
        }

        if (!checkDateRaw) {
            setExtractedCheckDate('');
            alert('No valid check date found in the file.');
            return;
        }

        setSelectedFile(file);
        setExtractedCheckDate(checkDateRaw);
    };

    const compareCheckDates = () => {
        console.log("dataCriteria.checkDate: " + dataCriteria.checkDate + "\nextractedCheckDate: " + extractedCheckDate);
        if (dataCriteria.checkDate !== extractedCheckDate) {
            setAlertShow(true);
            setAlertVariant('danger');
            setAlertMessage(
                "The check date you have entered does not match the check date in the selected file. Please enter: " + extractedCheckDate
            );
            return;
        }

        setCheckDateConfirmationModalShow(true);
    }


    const handleBlobUpload = async (skipFileTypeCheck = false) => {

        setCheckDateConfirmationModalShow(false);
        setInvoiceDateConfirmationModalShow(false);
        setTen99ConfirmationModalShow(false);

        //safeguard: the sniffed contents look like a different data type than the one selected.
        //this is a confirmation, not a block - the user can continue, and the backend parser
        //still validates the type as a final net.
        if (!skipFileTypeCheck && isFileKindMismatch(detectedFileKind, fileTypeCriteria.fileTypeId)) {
            setFileTypeMismatchModalShow(true);
            return;
        }
        setFileTypeMismatchModalShow(false);

        if (fileTypeCriteria.fileTypeId !== '1' && fileTypeCriteria.fileTypeId !== '2' && fileTypeCriteria.fileTypeId !== '4') {
            return;
        }

        if (fileTypeCriteria.fileTypeId === '2') {
            let [year, month, day] = dataCriteria.checkDate.split('-');

            const y = parseInt(year, 10);
            const m = parseInt(month, 10);

            const lastDay = new Date(y, m, 0).getDate();
            day = String(lastDay).padStart(2, '0');

            const updatedDate = `${year}-${month}-${day}`;

            setDataCriteria(prev => ({
                ...prev,
                checkDate: updatedDate
            }));
        }
        
        try {
            setDataStatus('loading')

            //reset progress indicator
            setProgressStatus(0);

            //create blob and get sas uri
            let blobSASUri = null;
            var processTypeId = fileTypeCriteria.fileTypeId === '1' ? 4 : fileTypeCriteria.fileTypeId === '2' ? 12 : 15; 
            await getBlobSASUri(processTypeId)
                .then(response => {
                    if (response.success) {
                        blobSASUri = response.data;
                        //continue to uploadBlob below...
                    }
                    else {
                        throw 'Failed:', response.statusText + ' : ' + response;
                    }
                });

            //uploadBlob
            await uploadBlob(blobSASUri)
                .then(response => {
                    if (response.success) {
                        //continue to createImportProcess below...
                    }
                    else {
                        throw 'Failed:', response.statusText + ' : ' + response;
                    }
                });

            //createImportProcess
            const urlSegmentsArray = blobSASUri.replace("//", "/").split("/");
            const urlSubSegmentsArray = urlSegmentsArray[urlSegmentsArray.length - 1].split("?");
            const fileName = urlSubSegmentsArray[0];
            await createImportProcess(fileName, processTypeId)
                .then(response => {
                    if (response.success) {
                        console.log('Success:', response.success);
                        setDataStatus('ready');

                        setAlertMessage("Document uploaded successfully!  We've received your document for processing, and will send you emails regarding the status of the import.");
                        setAlertShow(true);
                        setAlertVariant('success');

                        setTimeout(() => {
                            navigate('/datafiles', { state: { fileTypeId: fileTypeCriteria.fileTypeId } });
                        }, 1500);
                    }
                    else {
                        throw 'Failed:', response.statusText + ' : ' + response;
                    }
                });
        }
        catch (ex) {
            console.error('Error:', ex);
            setDataErrors(ex.message);
            setDataStatus('error');

            setAlertShow(true);
            setAlertVariant('danger');
            setAlertMessage('Upload failed.');
        }
        finally {

            //reset file selection
            setSelectedFile(null);
            setIsFilePicked(false);

            //set the alert to close after 10 seconds
            setTimeout(() => {
                setAlertShow(false);
            }, 10000);
        }

        //setTimeout(() => {
        //    navigate('/datafiles', { state: { fileTypeId: fileTypeCriteria.fileTypeId } });
        //}, 1500);

        return { success: true };
    };
    
    //import file
    const importFile = async () => {
        //console.log('Importing file...');

        const formData = new FormData();
        formData.append('uploadFile', selectedFile);

        const apiUrl = 'a_import?accountId=' + currentAccount.id + '&checkDate=' + dataCriteria.checkDate + '&description=' + dataCriteria.description;
        const body = formData;
        //console.log(apiUrl);
        //console.log('Json Body: ' + JSON.stringify(body));

        const response = await apiPost(apiUrl, body, false, getAccessTokenSilently);

        return { success: response.ok };
    }
    //
    //get blob sas uri
    const getBlobSASUri = async (processTypeId) => {
        //console.log('Getting SAS Uri...');

        const apiUrl = 'a_import/createblob?accountId=' + currentAccount.id + '&checkDate=' + dataCriteria.checkDate + '&description=' + dataCriteria.description + '&uploadFileName=' + selectedFile.name + '&processTypeId=' + processTypeId + '&ten99Version=' + dataCriteria.ten99Version;
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const blobSASUri = await response.text();
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', blobSASUri: ' + blobSASUri);

        return { success: response.ok, data: blobSASUri };
    }

    //upload blob using sas
    const uploadBlob = async (sasTokenUrl) => {
        console.log('Uploading blob...');

        const blockBlobClient = new BlockBlobClient(sasTokenUrl);
        setProgressStatus(0);
        const response = await blockBlobClient.uploadBrowserData(selectedFile, {
            blockSize: 4 * 1024 * 1024,
            concurrency: 20,
            onProgress: ev => setProgressStatus(Math.floor((ev.loadedBytes / selectedFile.size) * 100))
        })
            .then((result) => {
                return { success: true };
            })
            .catch((ex) => {
                return { success: false, statusText: ex.message };
            });

        return response;
    };

    //create import process
    const createImportProcess = async (fileName, processTypeId) => {
        //console.log('Creating import process...');

        const apiUrl = 'a_import/createimportprocess?accountId=' + currentAccount.id + '&checkDate=' + dataCriteria.checkDate + '&description=' + dataCriteria.description + '&fileName=' + fileName + '&processTypeId=' + processTypeId + '&ten99Version=' + dataCriteria.ten99Version;
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok);

        return { success: response.ok };
    }

    //test read xml
    const testReadXml = async () => {
        await GetTestReadXml()
            .then(response => {
                if (response.success === true) {
                    //do something
                }
                else {
                    //do something
                }
            })
            .catch(ex => {
                setPageStatus('error');
                setPageErrors(ex.message);

                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            });
    }

    //populate user profile
    const GetTestReadXml = async () => {
        //console.log('Getting User Profile...');

        const apiUrl = 'a_import/testreadxml';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok);

        return { success: response.ok };
    };

    //render page loading
    //note: spinner overlay will eventually be at the page level (I think)
    const showPageLoading = () => {
        return (
            <div>
                <Spinner
                    animation="border"
                    style={{ width: '3rem', height: '3rem', marginBottom: '1rem', color: COLORS.gold }}
                />
            </div>
        );
    }

    //render page loading
    const showDataLoading = () => {
        return (
            <>
                <Row>
                    <p><b>{(progressStatus == 0 ? 'Preparing to upload...' : (progressStatus == 100 ? 'Completing upload...' : ''))}</b></p>
                    <ProgressBar animated now={progressStatus} label={`${progressStatus}%`} />
                </Row>
            </>
        );
    }

    //render page error
    const showPageError = () => {
        return (
            <div>
                Oops, there was a page load error: {pageErrors}
            </div>
        );
    }

    //render data error
    const showDataError = () => {
        return (
            <Row>
                Oops, there was an import error: {dataErrors}
            </Row>
        );
    }

    ////render loading
    //const showLoading_BAK = () => {
    //    return (
    //        <div>
    //            <img src={spinnerIcon} alt="loading..." />
    //        </div>
    //    );
    //}

    //render table container
    const showTableContainer = () => {
        console.log("fileTypeId: " + fileTypeCriteria.fileTypeId);
        if (fileTypeCriteria.fileTypeId === "0") {
            return (
                <div>Select file type above...</div>
            );
        } else if (fileTypeCriteria.fileTypeId === "1" || (fileTypeCriteria.fileTypeId === "2") || (fileTypeCriteria.fileTypeId === "4")) {
            return (
                <Card className="mb-4">
                    <Card.Header style={{ ...header }}>
                        {showInputCriteria()}
                    </Card.Header>
                    <Card.Body>
                        {(() => {
                            switch (dataStatus) {
                                case 'loading':
                                    return showDataLoading()
                                case 'ready':
                                    return ((isFilePicked && (fileTypeCriteria.fileTypeId === '4' ? isTen99MISC : true)) ?
                                        <div>
                                            <p>Filename: {selectedFile.name}</p>
                                            <p>Filetype: {selectedFile.type}</p>
                                            <p>Size in bytes: {selectedFile.size}</p>
                                            <p>
                                                lastModifiedDate:{' '}
                                                {selectedFile.lastModifiedDate.toLocaleDateString()}
                                            </p>
                                            <Form.Group as={Col} className="mb-3" controlId="buttonSubmit">
                                                <Form.Label as={Row}><br /></Form.Label>
                                                {/*<Button*/}
                                                {/*    type='submit'*/}
                                                {/*    size="sm"*/}
                                                {/*    disabled={pageStatus !== 'ready'}*/}
                                                {/*    onClick={pageStatus === 'ready' ? handleSubmission : null}*/}
                                                {/*>*/}
                                                {/*    Upload/Import File*/}
                                                {/*</Button>      */}
                                                <Button
                                                    type='submit'
                                                    style={{
                                                        ...btnGold,
                                                        marginLeft: '20px',
                                                    }}
                                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                    size="sm"
                                                    disabled={pageStatus !== 'ready' || (isInvalid) || (fileTypeCriteria === '4' && (isVersionInvalid))}
                                                    onClick={() => {
                                                        if (pageStatus === 'ready') {
                                                            if (dataCriteria.checkDate && dataCriteria.ten99Version && fileTypeCriteria.fileTypeId === '4') {
                                                                setTen99ConfirmationModalShow(true)
                                                            } else if (dataCriteria.checkDate && fileTypeCriteria.fileTypeId === '2') {
                                                                //compareCheckDates();
                                                                setInvoiceDateConfirmationModalShow(true)
                                                            } else if (dataCriteria.checkDate && fileTypeCriteria.fileTypeId === '1') {
                                                                //compareCheckDates();
                                                                setCheckDateConfirmationModalShow(true)
                                                            } else {
                                                                if (fileTypeCriteria.fileTypeId === '4' && !dataCriteria.ten99Version) {
                                                                    setIsVersioninvalid(true);
                                                                    if (!dataCriteria.checkDate) {
                                                                        setIsinvalid(true);
                                                                    }
                                                                } else {
                                                                    setIsinvalid(true);
                                                                }
                                                            }
                                                        }
                                                    }} //used to be handleBlobUpload | setCheckDateConfirmationModalShow(true)
                                                >
                                                    Upload Data File
                                                </Button>
                                            </Form.Group>
                                            <p style={{ marginTop: '20px' }} >Status emails will be sent to {user.email}.  Thank you!</p>
                                        </div>
                                        : <p>Select a file to show details.</p>
                                    )
                                case 'error':
                                    return showDataError()
                                default:
                                    return <p></p>
                            }
                        })()}
                    </Card.Body>
                </Card>
            );
        } else {
            return (
                <div>Coming Soon...</div>
            );
        }
    }

    //render input criteria
    const showInputCriteria = () => {
        return (
            <Container fluid>
                <Form>
                    <Row className="g-4 align-items-end">
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="checkDate">                                
                                {(() => {
                                    switch (fileTypeCriteria.fileTypeId) {
                                        case '0':
                                            return <Form.Label style={formLabel}></Form.Label>
                                        case '1':
                                            return <Form.Label style={formLabel}>Check Date</Form.Label>
                                        case '2':
                                            return <Form.Label style={formLabel}>Invoice Date</Form.Label>
                                        case '4':
                                            return <Form.Label style={formLabel}>Tax Year</Form.Label>
                                        default:
                                            return <p></p>
                                    }
                                })()}
                                {(() => {
                                    switch (fileTypeCriteria.fileTypeId) {
                                        case '0':
                                        case '1':
                                            return <>
                                                <Form.Control
                                                    type="date"
                                                    placeholder="Check Date"
                                                    name="checkDate"
                                                    size="sm"
                                                    aria-label="Check Date"
                                                    value={dataCriteria.checkDate}
                                                    isInvalid={isInvalid}
                                                    onChange={handleChange}
                                                    style={{ ...inputSm }}
                                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter your check date.
                                                </Form.Control.Feedback>
                                            </>
                                        case '2':
                                            return <>
                                                <Form.Control
                                                    type="month"
                                                    placeholder="Invoice Date"
                                                    name="checkDate"
                                                    size="sm"
                                                    aria-label="InvoiceDate"
                                                    value={dataCriteria.checkDate}
                                                    isInvalid={isInvalid}
                                                    onChange={handleChange}
                                                    style={{ ...inputSm }}
                                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter your invoice date.
                                                    </Form.Control.Feedback>
                                            </>
                                        case '4':
                                            return <>
                                                <Form.Select
                                                    name="checkDate"
                                                    size="sm"
                                                    aria-label="PaymentYear"
                                                    value={dataCriteria.checkDate}
                                                    isInvalid={isInvalid}
                                                    onChange={handleChange}
                                                    style={{ ...inputSm }}
                                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                >
                                                    {years.map((year, i) => (
                                                        <option key={i} value={year}>{year}</option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter your tax year.
                                                </Form.Control.Feedback>
                                            </>
                                        default:
                                            return <p></p>
                                    }
                                })()}                               
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="checkDate">
                                {(() => {
                                    switch (fileTypeCriteria.fileTypeId) {
                                        case '0':
                                            break;
                                        case '1':
                                            break;
                                        case '2':
                                            break;
                                        case '4':
                                            return <Form.Label style={formLabel}>Version</Form.Label>
                                        default:
                                            return <p></p>
                                    }
                                })()}
                                {(() => {
                                    switch (fileTypeCriteria.fileTypeId) {
                                        case '0':
                                            break;
                                        case '1':
                                            break;
                                        case '2':
                                            break;
                                        case '4':
                                            return <>
                                                <Form.Select
                                                    name="ten99Version"
                                                    size="sm"
                                                    value={dataCriteria.ten99Version}
                                                    aria-label="Ten99Version"
                                                    isInvalid={isVersionInvalid}
                                                    onChange={handleChange}
                                                    style={{ ...inputSm }}
                                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                >
                                                        {/*<option value=""></option>*/}
                                                        <option value="Original">Original</option>
                                                        <option value="Revised">Revision</option>
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the version.
                                                </Form.Control.Feedback>
                                            </>
                                        default:
                                            return <p></p>
                                    }
                                })()}
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label style={formLabel}>Description</Form.Label>
                                <Form.Control
                                    name="description"
                                    size="sm"
                                    aria-label="Description"
                                    value={dataCriteria.description}
                                    onChange={handleChange}
                                    style={{ ...inputSm }}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group as={Col} className="mb-3" controlId="buttonSubmit">
                                <Form.Label as={Row} style={formLabel}>&nbsp;&nbsp;&nbsp;Supported file types: {acceptedExtensionsLabel}</Form.Label>
                                <Form.Control
                                    type="file"
                                    size="sm"
                                    disabled={pageStatus !== 'ready'}
                                    onChange={pageStatus === 'ready' ? changeHandler : null}
                                    accept={acceptedExtensions.join(', ')}
                                    style={{ ...inputSm }}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                />
                            </Form.Group>
                        </Col>

                        {/*<Col xs="auto">*/}
                        {/*    <Button*/}
                        {/*        size="sm"*/}
                        {/*        disabled={pageStatus !== 'ready'}*/}
                        {/*        style={{ marginLeft: '20px' }}*/}
                        {/*        onClick={pageStatus === 'ready' ? testReadXml : null}*/}
                        {/*    >*/}
                        {/*        TestReadXml*/}
                        {/*    </Button>*/}
                        {/*</Col>*/}
                    </Row>
                </Form>
            </Container>
        );
    }

    //render component
    return (
        <div>
            <Alert variant={alertVariant} show={alertShow} onClose={() => setAlertShow(false)} dismissible>
                {alertMessage}
            </Alert>

            {fileTypeCriteria.fileTypeId === "0" && (
                <>
                    <br /><br />
                    <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#333333', marginBottom: '4px', textAlign: 'center' }}>Import Files</p>
                    <div className="body flex-grow-1 px-3" style={{ marginTop: '0px' }}>
                        <Container fluid="lg">
                            <Row style={{ height: '25px' }} />
                            <Row className="justify-content-center" style={{ marginBottom: '30px' }}>
                                <p style={{ fontSize: '1.15rem', fontWeight: '500', color: '#7a9ab8', margin: 0, textAlign: 'center' }}>What are you importing?</p>
                            </Row>
                            <Row style={{ marginTop: '20px' }}>
                                <Container>
                                    <Row className="justify-content-center">
                                        <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                                            {[1, 2, 4].map(function (n) {
                                                var label = fileTypes[n] || ('Type ' + n);
                                                var isDisabled = ((n === 2 && !isJibEnabled) || (n === 4 && !is1099Enabled));
                                                var tileIcon = n === 1 ? faFileLines : n === 2 ? faFileArrowUp : faFileCode;
                                                var tileColor = n === 2 ? '#C8B568' : '#5B9BD5';
                                                var tileDesc = n === 1 ? 'Upload and process revenue data files' : n === 2 ? 'Upload and process JIB billing files' : 'Upload and process 1099 tax files';
                                                function onPick() {
                                                    if (isDisabled) return;
                                                    pickType(n);
                                                }
                                                function onKey(e) {
                                                    if (isDisabled) return;
                                                    if (e.key === 'Enter' || e.key === ' ') pickType(n);
                                                }
                                                return (
                                                    <Card
                                                        key={n}
                                                        className="mb-3"
                                                        role="button"
                                                        tabIndex={isDisabled ? -1 : 0}
                                                        aria-disabled={isDisabled}
                                                        style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', background: '#ffffff', border: '1px solid #e5e7eb', borderLeft: `3px solid ${tileColor}`, borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,.08)', transition: 'transform 150ms ease, box-shadow 150ms ease', ...(isDisabled ? { opacity: 0.5 } : {}) }}
                                                        onClick={onPick}
                                                        onKeyDown={onKey}
                                                        onMouseEnter={!isDisabled ? e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,.14)'; } : undefined}
                                                        onMouseLeave={!isDisabled ? e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,.08)'; } : undefined}
                                                    >
                                                        <Card.Header style={{ background: 'transparent', border: 'none', padding: '14px 16px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                                                                <div style={{ width: '38px', height: '38px', borderRadius: '9px', background: '#f3f4f6', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                    <FontAwesomeIcon icon={tileIcon} style={{ width: '16px', height: '16px', color: tileColor }} />
                                                                </div>
                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                    <div style={{ fontSize: '0.82rem', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '.06em', color: '#1f2937', lineHeight: '1.2' }}>{label}</div>
                                                                    <div style={{ fontSize: '0.78rem', color: '#6b7280', marginTop: '3px', fontWeight: '500', lineHeight: '1.3' }}>{tileDesc}</div>
                                                                </div>
                                                                <FontAwesomeIcon icon={faArrowRight} style={{ width: '13px', color: '#9ca3af', flexShrink: 0 }} />
                                                            </div>
                                                        </Card.Header>
                                                    </Card>
                                                );
                                            })}
                                        </Col>
                                    </Row>
                                </Container>
                            </Row>
                        </Container>
                    </div>
                </>
            )}

            {fileTypeCriteria.fileTypeId !== "0" && (
                <>
                    <br /><br />
                    {(() => {
                        switch (fileTypeCriteria.fileTypeId) {
                            case "1":
                                return <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#333333', marginBottom: '4px', textAlign: 'center' }}>Revenue Import</p>;
                            case "2":
                                return <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#333333', marginBottom: '4px', textAlign: 'center' }}>JIB Import</p>;
                            case "4":
                                return <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#333333', marginBottom: '4px', textAlign: 'center' }}>1099 Import</p>;
                            default:
                                return <p></p>;
                        }
                    })()}
                    <div className="body flex-grow-1 px-3" style={{ marginTop: '0px' }}>
                        <Container fluid="lg">
                            <Row style={{ height: '25px' }} />
                            <Row>
                                <div style={{ paddingBottom: '16px' }}>
                                    <button
                                        type="button"
                                        style={{ ...backBtn }}
                                        onClick={resetToSelection}
                                    >
                                        <FontAwesomeIcon icon={faArrowLeft} /> Back
                                    </button>
                                </div>
                                {(() => {
                                    switch (pageStatus) {
                                        case "loading":
                                            return showPageLoading();
                                        case "ready":
                                            return displayResultGrid === true ? showTableContainer() : <p></p>;
                                        case "error":
                                            return showPageError();
                                        default:
                                            return <p>No Page Loaded.</p>;
                                    }
                                })()}
                            </Row>
                        </Container>
                    </div>
                </>
            )}

            <CheckDateConfirmationModal
                show={checkDateConfirmationModalShow}
                onHide={() => setCheckDateConfirmationModalShow(false)}
                checkDate={dataCriteria.checkDate}
                handleBlobUpload={handleBlobUpload}
            />

            <InvoiceDateConfirmationModal
                show={invoiceDateConfirmationModalShow}
                onHide={() => setInvoiceDateConfirmationModalShow(false)}
                checkDate={dataCriteria.checkDate}
                handleBlobUpload={handleBlobUpload}
            />

            <Ten99ConfirmationModal
                show={ten99ConfirmationModalShow}
                onHide={() => setTen99ConfirmationModalShow(false)}
                checkDate={dataCriteria.checkDate}
                ten99Version={dataCriteria.ten99Version}
                handleBlobUpload={handleBlobUpload}
            />

            <FileTypeMismatchModal
                show={fileTypeMismatchModalShow}
                onHide={() => setFileTypeMismatchModalShow(false)}
                detectedLabel={fileKindLabel(detectedFileKind?.kind)}
                selectedLabel={fileKindLabel(fileKindForFileTypeId(fileTypeCriteria.fileTypeId))}
                handleBlobUpload={handleBlobUpload}
            />

        </div>
    );
}

export default Import;
